// extracted by mini-css-extract-plugin
export var carousel = "benefits-list-module--carousel--nI8Vq";